import { ComponentType, ReactElement } from 'react';

import { IconProps } from '@components/icons';
import { IconArray } from '@components/icons/array';
import { IconBoolean } from '@components/icons/boolean';
import { IconDate } from '@components/icons/date';
import { IconDecimalFloat } from '@components/icons/decimal-float';
import { IconEmail } from '@components/icons/email';
import { IconFile } from '@components/icons/file';
import { IconFiles } from '@components/icons/files';
import { IconForm } from '@components/icons/form';
import { IconList } from '@components/icons/list';
import { IconPhone } from '@components/icons/phone';
import { IconSelectSingle } from '@components/icons/select-single';
import { IconTextFormatLink } from '@components/icons/text-format-link';
import { IconTextFormatNumber } from '@components/icons/text-format-number';
import { IconTextLong } from '@components/icons/text-long';
import { IconTextShort } from '@components/icons/text-short';
import { getScopedTranslate } from '@locale/translate';
import { Color } from '@styles/index';

import { FieldType } from './field-mapping';

export const FIELD_MAPPING_ICON_COLOR: Color = 'elementPurple80';
export const FIELD_MAPPING_ICON_SIZE = 16;

export const FieldMappingIcon = ({ icon: Icon }: { icon: ReactElement<IconProps> }) => (
  <Icon.type {...Icon.props} size={FIELD_MAPPING_ICON_SIZE} color={FIELD_MAPPING_ICON_COLOR} />
);

export const fieldTypeIconMap: {
  [Key in FieldType]: ComponentType<IconProps>;
} = {
  text: IconTextShort,
  email: IconEmail,
  phone: IconPhone,
  date: IconDate,
  file: IconFile,
  form: IconForm,
  file_multi: IconFiles,
  options: IconList,
  select: IconSelectSingle,
  number: IconTextFormatNumber,
  boolean: IconBoolean,
  paragraph: IconTextLong,
  array: IconArray,
  array_of_strings: IconArray,
  multi_select: IconList,
  separator: () => null,
  decimal: IconDecimalFloat,
  webhookUrl: IconTextFormatLink,
};

const locale = {
  en: {
    text: 'Text',
    email: 'Email',
    phone: 'Phone number',
    date: 'Date',
    file: 'File',
    form: 'Form',
    file_multi: 'Files',
    options: 'Options',
    select: 'Select',
    number: 'Number',
    boolean: 'Boolean',
    paragraph: 'Paragraph',
    array: 'Array',
    array_of_strings: 'Array of strings',
    multi_select: 'Multi-select',
    separator: 'Separator',
    decimal: 'Decimal',
    webhookUrl: 'Webhook URL',
  },
};

const { t } = getScopedTranslate(locale);

export const fieldTypeLabelMap: {
  [Key in FieldType]: string;
} = {
  text: t('text'),
  email: t('email'),
  phone: t('phone'),
  date: t('date'),
  file: t('file'),
  form: t('form'),
  file_multi: t('file_multi'),
  options: t('options'),
  select: t('select'),
  number: t('number'),
  boolean: t('boolean'),
  paragraph: t('paragraph'),
  array: t('array'),
  array_of_strings: t('array_of_strings'),
  multi_select: t('multi_select'),
  separator: t('separator'),
  decimal: t('decimal'),
  webhookUrl: t('webhookUrl'),
};
